/* GTNSkeleton.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4FKVYE1Y8M%7Bpadding%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu81Y8M%7Bgap%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5E1Y8M%7Bpadding-inline-start%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCP1Y8M%7Bpadding-inline-end%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIgmnOE%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbYbGa%7Bdisplay%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VBntr%7Bheight%3A1lh%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A64rem)%7B._0THHewQ4SZ%7Bdisplay%3Aflex%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXlMbh7%7Bmax-width%3A680px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A30rem)%7B._2rTNeWvLZJ%7Bdisplay%3Ablock%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A30rem)%7B._2rTNeWYbGa%7Bdisplay%3Anone%7D%7D");
import { Fragment } from 'react';
import { TopNavEnd, TopNavMiddle, TopNavStart } from '@atlaskit/navigation-system';
import { MenuListItem } from '@atlaskit/navigation-system/top-nav-items';
import Skeleton from '@atlaskit/skeleton';
/**
 * The footprint every interactive control in the top nav occupies.
 *
 * `32px` is the size the top nav's own components use: `Search`'s field height,
 * `AppLogo`'s anchor height, and the icon button width `TopNavEnd` reserves for
 * its overflow menu. Every placeholder reserves this much space, so the bar does
 * not reflow when the real controls arrive.
 *
 * It is only *drawn* at this size where the control's own box fills it, as the
 * search field's does. A control holding an icon or an avatar draws that at
 * `ICON_SIZE` and reaches this footprint through `ICON_INSET` instead.
 */
const CONTROL_SIZE = 32;

/**
 * The size of the icon — or the profile's avatar — inside a control.
 *
 * Matches the `24px` icon container in ADS `AppLogo`/`CustomLogo`, the icon ADS
 * renders inside a top nav icon button, and the `small` `Avatar` that `Profile`
 * renders. All of them are smaller than the control they sit in, so they are
 * drawn at this size and inset by `ICON_INSET` — see `styles.icon`.
 */
const ICON_SIZE = 24;

/**
 * The space between an icon and the edge of the control around it.
 *
 * `4px` on every side, which is what takes a `24px` icon up to the
 * `CONTROL_SIZE` footprint the control occupies: `4 + 24 + 4 = 32`.
 */
const ICON_INSET = "var(--ds-space-050, 4px)";

/**
 * The width of the bar standing in for the app name text next to the app icon.
 *
 * The real width is the app's name rendered at `font.body`, which is unknown
 * here — this is an approximation of a typical name.
 */
const APP_NAME_WIDTH = 80;

/**
 * The height of a bar standing in for text, as `SkeletonMenuItemNext` sizes its
 * own: one cap height of the surrounding font, rounded to whole pixels so the
 * bar lands on the pixel grid.
 *
 * This is a text bar rather than a control, so it is sized from the text it
 * replaces rather than to a fixed height — the wrapper sets the font it is
 * measured against.
 */
const TEXT_HEIGHT = 'round(1cap, 1px)';

/**
 * How many `TopNavEnd` placeholders the skeleton renders, on top of the
 * profile one that always comes last.
 *
 * Which end slots exist is decided by the consuming app — it passes one slot
 * per control — so the real count is unknowable here. Four is an
 * approximation of a typical app: notifications, help, settings, and one
 * app-specific action.
 */
const TOP_NAV_END_ITEM_COUNT = 4;
const styles = {
  icon: "_4FKVYE1Y8M _3iDTPbQ4SZ",
  appHome: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT _0LQT5E1Y8M _03SyCP1Y8M",
  appName: "_2sNsIgmnOE _3iDTPbYbGa _0jFU0VBntr _0hPCNLDIqT _0THHewQ4SZ",
  searchField: "_3iDTPbYbGa _39xV02N91d _1EqgXlMbh7 _2rTNeWvLZJ",
  searchIconButton: "_4FKVYE1Y8M _3iDTPbQ4SZ _2rTNeWYbGa"
};

/**
 * A placeholder for the global top navigation, for consumers to render while
 * the top nav's data is still in flight.
 *
 * This renders the top nav's *contents* only. Place it inside the `TopNav`
 * layout element, where `GlobalTopNavigation` would otherwise go — `TopNav`
 * itself owns the bar's height and background, and is what stops the page
 * reflowing when the real navigation arrives.
 *
 * It is built from the same layout components the real nav uses —
 * `TopNavStart`, `TopNavMiddle` and `TopNavEnd` — so the three areas are
 * positioned, spaced and made responsive by those components rather than by
 * numbers copied out of them, and the skeleton cannot drift as that layout
 * changes. Only the leaves are stand-ins: a shimmering `Skeleton` per control,
 * each reserving that control's footprint and drawn as the thing it replaces —
 * an icon, an avatar, a text bar, or the search field itself.
 *
 * What it cannot mirror exactly is *how many* controls there will be. Every
 * top nav slot is optional and supplied by the app, so the counts here are
 * fixed approximations of a typical app (see the constants above).
 */
export function GTNSkeleton(): React.JSX.Element {
  return <Fragment>
			<TopNavStart sideNavToggleButton={<div className={ax([styles.icon])}>
						<Skeleton width={ICON_SIZE} height={ICON_SIZE} borderRadius={"var(--ds-radius-small, 4px)"} isShimmering testId="gtn-skeleton-side-nav-toggle" />
					</div>}>
				<div className={ax([styles.icon])}>
					<Skeleton width={ICON_SIZE} height={ICON_SIZE} borderRadius={"var(--ds-radius-small, 4px)"} isShimmering testId="gtn-skeleton-app-switcher" />
				</div>
				<div className={ax([styles.appHome])}>
					<div className={ax([styles.icon])}>
						<Skeleton width={ICON_SIZE} height={ICON_SIZE} borderRadius={"var(--ds-radius-small, 4px)"} isShimmering testId="gtn-skeleton-app-icon" />
					</div>
					<div className={ax([styles.appName])}>
						<Skeleton width={APP_NAME_WIDTH} height={TEXT_HEIGHT} borderRadius={"var(--ds-radius-full, 9999px)"} isShimmering testId="gtn-skeleton-app-name" />
					</div>
				</div>
			</TopNavStart>
			<TopNavMiddle>
				{/* `TopNavMiddle` requires the search to be its first child. */}
				<div className={ax([styles.searchField])}>
					<Skeleton width="100%" height={CONTROL_SIZE} borderRadius={"var(--ds-radius-small, 4px)"} isShimmering testId="gtn-skeleton-search" />
				</div>
				<div className={ax([styles.searchIconButton])}>
					<Skeleton width={ICON_SIZE} height={ICON_SIZE} borderRadius={"var(--ds-radius-small, 4px)"} isShimmering testId="gtn-skeleton-search-icon-button" />
				</div>
			</TopNavMiddle>
			<TopNavEnd>
				{/*
     * `TopNavEnd` gives its children `role="list"`, so each placeholder
     * is wrapped in the same `MenuListItem` the real end items use --
     * a bare element here would leave the list without list items.
     */}
				{Array.from({
        length: TOP_NAV_END_ITEM_COUNT
      }, (_, index) => <MenuListItem key={index}>
						<div className={ax([styles.icon])}>
							<Skeleton width={ICON_SIZE} height={ICON_SIZE} borderRadius={"var(--ds-radius-small, 4px)"} isShimmering testId="gtn-skeleton-end-item" />
						</div>
					</MenuListItem>)}
				<MenuListItem>
					{/*
      * Profile is last in the real top nav, and is the one end item that
      * is round, because it renders an avatar rather than an icon. The
      * avatar is the same size as those icons and sits in the same
      * control, so it is drawn and inset the same way.
      */}
					<div className={ax([styles.icon])}>
						<Skeleton width={ICON_SIZE} height={ICON_SIZE} borderRadius={"var(--ds-radius-full, 9999px)"} isShimmering testId="gtn-skeleton-profile" />
					</div>
				</MenuListItem>
			</TopNavEnd>
		</Fragment>;
}